export const formatDistance = (distance: number): string => {
  if (distance === null) return '-';
  const distanceFormatter = new Intl.NumberFormat([], {
    style: 'decimal',
    maximumFractionDigits: 2,
  });

  return `${distanceFormatter.format(distance)} km`;
};
